import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import sessionReducer from './session';
import brandReducer from './brand';
import planReducer from './plan';
import vendorReducer from './vendor';
import uiReducer from './ui';
import cardReducer from './card';
import routeReducer from './routes';

const rootReducer = combineReducers({
  routerState: routerReducer,
  routeState: routeReducer,
  sessionState: sessionReducer,
  brandState: brandReducer,
  planState: planReducer,
  vendorState: vendorReducer,
  cardState: cardReducer,
  uiState: uiReducer,
});

export default rootReducer;
